export default {"src":"/_next/static/media/ChinChin_small.1d90f30b.svg","height":193,"width":192,"blurWidth":0,"blurHeight":0};